import {
  SET_EMBEDDINGS,
} from './types';
import { SetRegValueHelper, SpreadOps } from '../helper';

const initialState = {
  list: [],
};

var temp = "";
initialState.values = SpreadOps({ ...initialState.default });

export default function (state = initialState, action) {
  switch (action.type) {

    case SET_EMBEDDINGS:
      return {
        ...state,
        list: action.data.list,
      }

    default:
      return state

  }
}
